import React, { ButtonHTMLAttributes } from 'react'

import { t } from '@/i18n'
import { useCanUpdate } from '@/hooks'
type Props = ButtonHTMLAttributes<HTMLButtonElement>

const FormEditButton: React.FC<Props> = ({ onClick, ...rest }) => {
  const canUpdate = useCanUpdate()
  if (!canUpdate) return null

  return (
    <button className="main-btn edit-form-button" onClick={onClick} {...rest}>
      {t('edit')}
    </button>
  )
}

export default FormEditButton
